// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs"
import Turbolinks from "turbolinks"
import jQuery from "jquery"
import "../stylesheets/application"
import "bootstrap"
import "../src/noukaweb.js"
import "../src/loading.js"
import "../src/favorites.js"

const applicationPackScript = document.currentScript;
if (applicationPackScript && applicationPackScript.src) {
    __webpack_public_path__ = new URL('../', applicationPackScript.src).href;
}

global.jQuery = global.$ = globalThis.jQuery = globalThis.$ = jQuery;

let selectionTreePromise;
window.loadSelectionTree = function() {
    if (!selectionTreePromise) {
        selectionTreePromise = import("jstree");
    }
    return selectionTreePromise;
};

let productPrintPromise;
window.loadProductPrint = function() {
    if (!productPrintPromise) {
        productPrintPromise = import("../src/product_print.js");
    }
    return productPrintPromise;
};

let dataTablesPromise;
function loadDataTables() {
    if (!dataTablesPromise) {
        dataTablesPromise = import("datatables.net").then(function() {
            return import("datatables.net-bs5");
        });
    }
    return dataTablesPromise;
}

function initializeDataTables() {
    const tables = document.querySelectorAll('[data-datatable-order]');
    if (tables.length === 0) return;

    loadDataTables().then(function() {
        tables.forEach(function(tableElement) {
            if (!document.documentElement.contains(tableElement) || !tableElement.id ||
                jQuery.fn.DataTable.isDataTable(tableElement)) return;

            const searchLabel = tableElement.dataset.datatableSearchLabel || '検索:';
            const searchPlaceholder = tableElement.dataset.datatableSearchPlaceholder || 'キーワードを入力';
            const sortDirection = tableElement.dataset.datatableDirection || 'desc';
            const table = jQuery(tableElement).DataTable({
                autoWidth: tableElement.dataset.datatableAutoWidth !== 'false',
                language: {
                    emptyTable: 'テーブルにデータがありません',
                    info: '_TOTAL_件中 _START_件から _END_件まで表示',
                    infoEmpty: '0件中 0件から 0件まで表示',
                    infoFiltered: '',
                    lengthMenu: '_MENU_件表示',
                    loadingRecords: '読み込み中...',
                    processing: '処理中...',
                    search: searchLabel,
                    zeroRecords: '一致するデータがありません',
                    paginate: {first: '先頭', last: '最終', next: '次', previous: '前'}
                },
                order: [[Number(tableElement.dataset.datatableOrder), sortDirection]]
            });
            const tableWrapper = tableElement.closest('.dataTables_wrapper');
            const searchInput = tableWrapper && tableWrapper.querySelector('.dataTables_filter input');
            if (searchInput) {
                searchInput.setAttribute('aria-label', searchLabel.replace(/[:：]\s*$/, ''));
                searchInput.setAttribute('placeholder', searchPlaceholder);
            }
            table.on('preDraw.dt', function() {
                jQuery('#loading-indicator').removeClass('d-none');
            });
            table.on('draw.dt', function() {
                jQuery('#loading-indicator').addClass('d-none');
            });
            table.on('page.dt', function() {
                jQuery('html, body').animate({
                    scrollTop: jQuery('.dataTables_wrapper').offset().top - 70
                }, 'slow');
            });

            if (tableElement.dataset.captureForPrint === 'true') {
                window.loadProductPrint().then(function() {
                    window.captureProductPrintTable(`#${tableElement.id}`);
                });
            }
        });
    }).catch(function(error) {
        console.error('DataTablesの読み込みに失敗しました。', error);
    });
}

function initializeScrollHints() {
    const tables = document.querySelectorAll('.table-responsive:not(.scroll-hint)');
    if (tables.length === 0) return;

    tables.forEach(function(table) {
        table.classList.add('js-scrollable');
    });
    import("../src/scroll-hint.min.js").then(function(module) {
        const ScrollHint = module.default || module;
        new ScrollHint(tables, {
            i18n: {
                scrollable: 'スクロールできます'
            }
        });
    });
}

let productSectionNavigationCleanup;

function initializeProductSectionNavigation() {
    if (productSectionNavigationCleanup) {
        productSectionNavigationCleanup();
        productSectionNavigationCleanup = null;
    }

    const navigation = document.querySelector('.product-section-nav');
    if (!navigation) return;

    const scrollContainer = navigation.querySelector('.product-section-nav-scroll');
    const sectionLinks = Array.from(navigation.querySelectorAll('[data-product-section-link]'));
    const sectionEntries = sectionLinks.map(function(link) {
        const href = link.getAttribute('href');
        return {
            link: link,
            section: href && href.charAt(0) === '#' ? document.getElementById(href.slice(1)) : null
        };
    }).filter(function(entry) {
        return entry.section;
    });

    if (sectionEntries.length === 0) return;

    let activeLink;
    let animationFrameId;

    function keepActiveLinkVisible(link) {
        if (!scrollContainer || scrollContainer.scrollWidth <= scrollContainer.clientWidth) return;

        const visibleStart = scrollContainer.scrollLeft;
        const visibleEnd = visibleStart + scrollContainer.clientWidth;
        const linkStart = link.offsetLeft;
        const linkEnd = linkStart + link.offsetWidth;
        if (linkStart >= visibleStart && linkEnd <= visibleEnd) return;

        const targetLeft = Math.max(0, linkStart - (scrollContainer.clientWidth - link.offsetWidth) / 2);
        const prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (typeof scrollContainer.scrollTo === 'function') {
            scrollContainer.scrollTo({left: targetLeft, behavior: prefersReducedMotion ? 'auto' : 'smooth'});
        } else {
            scrollContainer.scrollLeft = targetLeft;
        }
    }

    function setActiveLink(link) {
        if (!link || activeLink === link) return;

        sectionLinks.forEach(function(sectionLink) {
            const isActive = sectionLink === link;
            sectionLink.classList.toggle('is-active', isActive);
            if (isActive) {
                sectionLink.setAttribute('aria-current', 'location');
            } else {
                sectionLink.removeAttribute('aria-current');
            }
        });
        activeLink = link;
        keepActiveLinkVisible(link);
    }

    function updateActiveLink() {
        const navigationTop = parseFloat(window.getComputedStyle(navigation).top) || 0;
        const activationLine = navigationTop + navigation.offsetHeight + 24;
        let activeEntry = sectionEntries[0];

        sectionEntries.forEach(function(entry) {
            if (entry.section.getBoundingClientRect().top <= activationLine) {
                activeEntry = entry;
            }
        });

        const pageBottom = window.pageYOffset + window.innerHeight;
        if (pageBottom >= document.documentElement.scrollHeight - 2) {
            activeEntry = sectionEntries[sectionEntries.length - 1];
        }

        setActiveLink(activeEntry.link);
        animationFrameId = null;
    }

    function requestActiveLinkUpdate() {
        if (animationFrameId) return;
        animationFrameId = window.requestAnimationFrame(updateActiveLink);
    }

    const clickHandlers = sectionEntries.map(function(entry) {
        const handler = function() {
            setActiveLink(entry.link);
        };
        entry.link.addEventListener('click', handler);
        return {link: entry.link, handler: handler};
    });

    window.addEventListener('scroll', requestActiveLinkUpdate, {passive: true});
    window.addEventListener('resize', requestActiveLinkUpdate);
    window.addEventListener('hashchange', requestActiveLinkUpdate);
    updateActiveLink();

    productSectionNavigationCleanup = function() {
        window.removeEventListener('scroll', requestActiveLinkUpdate);
        window.removeEventListener('resize', requestActiveLinkUpdate);
        window.removeEventListener('hashchange', requestActiveLinkUpdate);
        clickHandlers.forEach(function(item) {
            item.link.removeEventListener('click', item.handler);
        });
        if (animationFrameId) {
            window.cancelAnimationFrame(animationFrameId);
        }
    };
}

document.addEventListener('turbolinks:load', function() {
    $(function() {
        $('[data-bs-toggle="popover"]').popover();
    });

    $(function() {
        var ads = document.querySelectorAll('.adsbygoogle');
        if (ads.length > 0) {
            ads.forEach(function (ad) {
                if (ad.firstChild) {
                    ad.removeChild(ad.firstChild);
                }
                window.adsbygoogle = window.adsbygoogle || [];
                window.adsbygoogle.push({});
            });
        }
    });

    if ($('#quickSearchWords').length) {
        const textBoxString = $('#quickSearchWords').val();
        if(textBoxString.match(/^[ 　\r\n\t]*$/)) {
            changeStateButton('#quickSearchSubmitButton', false);
        }
    }
    if ($('#productSearchWords').length) {
        const textBoxString = $('#productSearchWords').val();
        if(textBoxString.match(/^[ 　\r\n\t]*$/)) {
            changeStateButton('#productSearchSubmitButton', false);
        }
    }

    initializeScrollHints();
    initializeDataTables();
    initializeProductSectionNavigation();
    if (document.body.classList.contains('product-detail-page')) {
        window.loadProductPrint();
    }

    $('#purposeAll').on('click', function() {
        if ($('#purposeCheckboxes :checked').length === $('#purposeCheckboxes :input').length) {
            $('#purposeAll').text('全選択');
            $('#purposeCheckboxes input[type="checkbox"]').prop('checked', false);
        } else {
            $('#purposeAll').text('全解除');
            $('#purposeCheckboxes input[type="checkbox"]').prop('checked', true);
        }
        checkStateQuickSearchForm();
    });

    $('#purposeCheckboxes input[type="checkbox"]').on('click', function() {
        if ($('#purposeCheckboxes :checked').length === $('#purposeCheckboxes :input').length) {
            $('#purposeAll').text('全解除');
        } else {
            $('#purposeAll').text('全選択');
        }
        checkStateQuickSearchForm();
    });

    $('#quickSearchWords').on('input', function() {
        checkStateQuickSearchForm();
    });

    $('#productSearchWords').on('input', function() {
        checkStateProductSearchForm();
    });

    function checkStateQuickSearchForm() {
        const isTextBoxEnabled = checkTextBox($('#quickSearchWords').val(), '#errorQuickSearchWords', '検索するワードを入力してください。');
        const isCheckBoxEnabled = checkCheckBoxes('#purposeCheckboxes', '#errorPurposeCheckboxes', 'どれか一つは必ず選択してください。');
        changeStateButton('#quickSearchSubmitButton', isTextBoxEnabled && isCheckBoxEnabled);
    }

    function checkStateProductSearchForm() {
        const isTextBoxEnabled = checkTextBox($('#productSearchWords').val(), '#errorProductSearchWords', '検索するワードを入力してください。');
        changeStateButton('#productSearchSubmitButton', isTextBoxEnabled);
    }

    function generateErrorDisplayCode(displayErrorText) {
        return '<p class="text-danger">' +
               '  <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" fill=\"currentColor\" class=\"bi bi-exclamation-triangle\" viewBox=\"0 0 16 16\">\n' +
               '    <path d=\"M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z\"/>\n' +
               '    <path d=\"M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z\"/>\n' +
               '  </svg>' +
               displayErrorText +
               '</p>'
    }

    function checkTextBox(checkTextBoxString, errorDivId, displayErrorText) {
        $(errorDivId + ' p').remove();
        let result = true;
        let textBox = $.trim(checkTextBoxString);

        if(textBox.match(/^[ 　\r\n\t]*$/)) {
            $(errorDivId).append(generateErrorDisplayCode(displayErrorText));
            result = false;
        }
        return result;
    }

    function changeStateButton(buttonId, isEnabled) {
        if(isEnabled) {
            $(buttonId).prop('disabled', false);
        } else {
            $(buttonId).prop('disabled', true);
        }
    }

    function checkCheckBoxes(checkBoxesId, errorDivId, displayErrorText) {
        $(errorDivId + ' p').remove();
        let result = true;
        let checkCount = 0;

        $(checkBoxesId + ' input[type="checkbox"]').each(function() {
            if ($(this).prop('checked')) {
                checkCount = checkCount + 1;
            }
        });

        if(checkCount === 0) {
            $(errorDivId).append(generateErrorDisplayCode(displayErrorText));
            result = false;
        }
        return result;
    }
});

document.addEventListener('turbolinks:before-cache', function() {
    if (productSectionNavigationCleanup) {
        productSectionNavigationCleanup();
        productSectionNavigationCleanup = null;
    }
});

document.addEventListener('turbolinks:before-cache', function() {
    if (!jQuery.fn.DataTable) return;

    document.querySelectorAll('[data-datatable-order]').forEach(function(tableElement) {
        if (jQuery.fn.DataTable.isDataTable(tableElement)) {
            jQuery(tableElement).DataTable().destroy();
        }
    });
});

Rails.start();
Turbolinks.start();
